(function ($) {
    var $html = $('html');
    var userAgent = navigator.userAgent;
    var appVersion = navigator.appVersion;

    var browserClasses = [
        { id: 'MSIE', className: 'ie' },
        { id: 'MSIE 8', className: 'ie8' },
        { id: 'MSIE 9', className: 'ie9' },
        { id: 'MSIE 10', className: 'ie10' },
        { id: 'Mac OS X', className: 'mac' }
    ];

    browserClasses.forEach(function (browser) {
        if (appVersion.indexOf(browser.id) !== -1) {
            $html.addClass(browser.className);
        }
    });

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        $html.addClass('ios');
    }

    if (/Android/.test(userAgent) && !window.MSStream) {
        $html.addClass('android');
    }

    if (/Trident\/7\./.test(userAgent)) {
        $html.addClass('ie11');
    }

    $.publish('xom.browsers-detected');
}(window.jQuery));